import { ApiTypes } from '@mode/shared/contract-common';

export function getLinkHref(resource: ApiTypes.ModeResource, name: string): string {
  return resource != null && resource.hasLink(name) && resource.links(name).href;
}
